export default "__VITE_ASSET__CqvfATII__"